import axios, { AxiosInstance } from "axios";
import { config } from "@/config";
import { ApiInterceptors } from "./interceptors";

export class ApiClient {
  private api: AxiosInstance;
  public interceptors: ApiInterceptors;

  constructor() {
    this.api = axios.create({
      baseURL: config.api.baseUrl,
      timeout: 10000,
      headers: {
        "Content-Type": "application/json",
      },
    });

    // Initialize interceptors
    this.interceptors = new ApiInterceptors(this.api);

    // Load stored token on initialization
    this.interceptors.loadStoredToken();
  }

  getInstance(): AxiosInstance {
    return this.api;
  }

  setAuthToken(token: string) {
    this.interceptors.setAuthToken(token);
  }

  logout() {
    this.interceptors.clearAuthToken();
  }

  getAuthToken(): string | null {
    return this.interceptors.getAuthToken();
  }
}

// Create and export a singleton instance
export const apiClient = new ApiClient();
export default apiClient;
